import BusinessToCustomer from "../../../jsx/components/Dashboard/BusinessToCustomer/businesstocustomer";

const MyLeadsWrapper = () => {
  return <BusinessToCustomer />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(MyLeadsWrapper);
